import React from "react"
import Project from "../components/project"
import Layout from "../components/layout"
import SEO from "../components/seo"
import './index.scss'

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <section className='home-intro-container'>
      <div className='home-heading'>
        <h1>Developer</h1>
        <h1>Problem Solver</h1>
        <h1>Curious</h1>
      </div>
      <div className='home-summary'>
        <p>Hi, I'm Taqwa. I build fast, thoughtful websites.</p>
        <p>I'm a third culture kid and armchair beekeeper who loves sci-fi and zombie fiction, and I'm always down a Wikipedia rabbit hole about some historical figure or random moment in history.</p>
        <p>Catch me panic-reading library eBook loans 3 hours before they're due.</p>
      </div>
    </section>
    <section className="projects">
      <h1 className="projects-title">Select Work</h1>
      <ul className="project-grid">
        <Project 
          projectLink="/work/ppfa-crisis-courts"
          projectImageURL="/work/images/crisis-in-courts-1.jpg"
          projectImageAlt="Crisis in The Courts card / site homepage screenshot"
          projectTitle="Crisis in The Courts"
        />
        <Project 
          projectLink="/work/legal-services-nyc"
          projectImageURL="/work/images/legal-services-nyc-1.png"
          projectImageAlt="Legal Services NYC site graphic"
          projectTitle="Legal Services NYC"
        />
        <Project
          projectLink="/work/economic-security-project"
          projectImageURL="/work/images/economic-security-project-1.png"
          projectImageAlt="Economic Security Project site graphic"
          projectTitle="Economic Security Project"
        />
      </ul>
    </section>
  </Layout>
)

export default IndexPage
